import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const groupItemTemplateCategorysApi = {
    getGroupItemTemplateCategorys: (): Observable<Dtos.GetGroupItemTemplateCategorysResponse> => {
        //Create the request.
        let request: Dtos.GetGroupItemTemplateCategorys = new Dtos.GetGroupItemTemplateCategorys();

        //Send request.
        const response: Promise<Dtos.GetGroupItemTemplateCategorysResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getGroupItemTemplateCategoryById: (id: number): Observable<Dtos.GetGroupItemTemplateCategoryByIdResponse> => {
        //Create the request.
        let request: Dtos.GetGroupItemTemplateCategoryById = new Dtos.GetGroupItemTemplateCategoryById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetGroupItemTemplateCategoryByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setGroupItemTemplateCategory: (groupItemTemplateCategory: Dtos.GroupItemTemplateCategory): Observable<Dtos.SetGroupItemTemplateCategoryResponse> => {

        let request: Dtos.SetGroupItemTemplateCategory = new Dtos.SetGroupItemTemplateCategory();

        request.groupItemTemplateCategory = groupItemTemplateCategory;

        // send request
        const response: Promise<Dtos.SetGroupItemTemplateCategoryResponse> = client.post(request);

        return Observable.from(response);

    },
    createGroupItemTemplateCategory: (): Observable<Dtos.CreateGroupItemTemplateCategoryResponse> => {
        //Create the request.
        let request: Dtos.CreateGroupItemTemplateCategory = new Dtos.CreateGroupItemTemplateCategory();

        //Send request.
        const response: Promise<Dtos.CreateGroupItemTemplateCategoryResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateGroupItemTemplateCategory: (groupItemTemplateCategory: Dtos.GroupItemTemplateCategory): Observable<Dtos.ValidateGroupItemTemplateCategoryResponse> => {

        let request: Dtos.ValidateGroupItemTemplateCategory = new Dtos.ValidateGroupItemTemplateCategory();

        request.groupItemTemplateCategory = groupItemTemplateCategory;

        // send request
        const response: Promise<Dtos.ValidateGroupItemTemplateCategoryResponse> = client.post(request);

        return Observable.from(response);

    },
}